import api from 'api'
import {
  CACHE_TAG_SUSPENSION_PRORATION,
  CACHE_TAG_SUSPENSION_AUTOMATION,
  CACHE_TAG_ACCOUNT_RENTAL_FEE_SETTINGS,
  CACHE_TAG_ACCOUNT_DETAILS_BY_ID,
  CACHE_TAG_SUSPENSION_PRORATION_VERSION_LIST,
  CACHE_TAG_SUSPENSION_AUTOMATION_VERSION_LIST,
  CACHE_TAG_RENTAL_BILLING_SETTINGS_VERSION_LIST,
  CACHE_TAG_ACCOUNT_DETAILS,
  CACHE_TAG_WORK_ORDER_LIST,
  CACHE_TAG_WORK_ORDER_LIST_SUMMARY,
} from '../cacheTagTypes'

const extendedApi = api.injectEndpoints({
  endpoints: builder => ({
    getSuspensionProration: builder.query({
      query: ({ accountId }) => ({
        url: `/api/v1/core/accounts/${accountId}/suspension-proration`,
        method: 'GET',
      }),
      providesTags: (result, error, { accountId }) => [
        CACHE_TAG_SUSPENSION_PRORATION,
        { type: CACHE_TAG_SUSPENSION_PRORATION, id: accountId },
      ],
    }),
    updateSuspensionProration: builder.mutation({
      query: ({ accountId, prorationEnabled, inheritFromBillingProfile }) => ({
        url: `/api/v1/core/accounts/${accountId}/suspension-proration`,
        method: 'PATCH',
        body: { prorationEnabled, inheritFromBillingProfile },
      }),
      invalidatesTags: (result, error, { accountId }) => [
        CACHE_TAG_SUSPENSION_PRORATION,
        CACHE_TAG_WORK_ORDER_LIST,
        CACHE_TAG_WORK_ORDER_LIST_SUMMARY,
        { type: CACHE_TAG_SUSPENSION_PRORATION, id: accountId },
        { type: CACHE_TAG_ACCOUNT_DETAILS_BY_ID, id: accountId },
        { type: CACHE_TAG_SUSPENSION_PRORATION_VERSION_LIST, id: accountId },
      ],
    }),

    getSuspensionAutomation: builder.query({
      query: ({ accountId }) => ({
        url: `/api/v1/core/accounts/${accountId}/suspension-automation`,
        method: 'GET',
      }),
      providesTags: (result, error, { accountId }) => [
        CACHE_TAG_SUSPENSION_AUTOMATION,
        { type: CACHE_TAG_SUSPENSION_AUTOMATION, id: accountId },
      ],
    }),
    updateSuspensionAutomation: builder.mutation({
      query: ({
        accountId,
        automationEnabled,
        daysLateEnabled,
        daysLateThreshold,
        suspendWhenBalanceExceedsCreditLimit,
        inheritFromBillingProfile,
      }) => ({
        url: `/api/v1/core/accounts/${accountId}/suspension-automation`,
        method: 'PATCH',
        body: { automationEnabled, daysLateEnabled, daysLateThreshold, suspendWhenBalanceExceedsCreditLimit, inheritFromBillingProfile },
      }),
      invalidatesTags: (result, error, { accountId }) => [
        CACHE_TAG_ACCOUNT_DETAILS,
        CACHE_TAG_SUSPENSION_AUTOMATION,
        CACHE_TAG_WORK_ORDER_LIST,
        CACHE_TAG_WORK_ORDER_LIST_SUMMARY,
        { type: CACHE_TAG_SUSPENSION_AUTOMATION, id: accountId },
        { type: CACHE_TAG_ACCOUNT_DETAILS_BY_ID, id: accountId },
        { type: CACHE_TAG_SUSPENSION_AUTOMATION_VERSION_LIST, id: accountId },
      ],
    }),

    getAccountRentalFeeSettings: builder.query({
      query: ({ accountId }) => ({
        url: `/api/v1/core/accounts/${accountId}/rental-billing-settings`,
        method: 'GET',
      }),
      providesTags: (result, error, { accountId }) => [
        CACHE_TAG_ACCOUNT_RENTAL_FEE_SETTINGS,
        { type: CACHE_TAG_ACCOUNT_RENTAL_FEE_SETTINGS, id: accountId },
      ],
    }),
    updateAccountRentalFeeSettings: builder.mutation({
      query: ({ accountId, incompleteRentalPeriods, rentalFeeOnSuspension }) => ({
        url: `/api/v1/core/accounts/${accountId}/rental-billing-settings`,
        method: 'PATCH',
        body: { incompleteRentalPeriods, rentalFeeOnSuspension },
      }),
      invalidatesTags: (result, error, { accountId }) => [
        CACHE_TAG_ACCOUNT_RENTAL_FEE_SETTINGS,
        { type: CACHE_TAG_ACCOUNT_RENTAL_FEE_SETTINGS, id: accountId },
        { type: CACHE_TAG_ACCOUNT_DETAILS_BY_ID, id: accountId },
        { type: CACHE_TAG_RENTAL_BILLING_SETTINGS_VERSION_LIST, id: accountId },
      ],
    }),
  }),
})

export const {
  useLazyGetSuspensionProrationQuery,
  useUpdateSuspensionProrationMutation,
  useLazyGetSuspensionAutomationQuery,
  useUpdateSuspensionAutomationMutation,
  useLazyGetAccountRentalFeeSettingsQuery,
  useUpdateAccountRentalFeeSettingsMutation,
} = extendedApi
